<template>
    <modal name="registro" :scrollable="true" :height="'auto'">
    <div class="container p-4">
        <div class="text-center">
            <h3>Ingresa los datos</h3>
            <hr>
        </div>
        <div class="col-5 ml-2">
            <label class="form-label">Tipo</label>
            <select v-model="tipo" class="form-select form-select-sm" @change="changeTipo">
                <option selected disabled value="0">--Selecciona</option>
                <option value="1">Hospitales</option>
                <option value="2">Honorarios</option>
                <option value="3">Proveedores</option>
            </select>
        </div>
        <div v-if="tipo == 1" class="p-4">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">RFC</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="rfc" @input="validateRFC">
                        <span class="invalidEmail" v-if="!valiRFC">Por favor, introduce un RFC que sea válido. </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Razon Social</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="razon">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">Nombre Comercial</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="nombreComercial">
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="email" @input="validateEmail">
                        <span class="invalidEmail" v-if="!validEmailHospitales">Por favor, introduce un correo electrónico válido.</span>
                    </div>
                </div>
            </div>
            
        </div>
        <div v-if="tipo == 2" class="p-4">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">RFC</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="rfc" @input="validateRFC">
                        <span class="invalidEmail" v-if="!valiRFC">Por favor, introduce un RFC válido.</span>
                    </div>
                    
                </div>
                <div class="col-md-6">
                    <label class="form-label">Nombre(s)</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="nombres">
                    </div>
                    
                </div>
                
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">Apellido Paterno</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="paterno">
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Apellido Materno</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="materno">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="email" @input="validateEmail">
                        <span class="invalidEmail" v-if="!validEmailHonorarios">Por favor, introduce un correo electrónico válido.</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Teléfono de Contacto</label>
                    <input type="text" class="form-control" v-model="telefono">
                </div>
            </div>
        </div>
        <div v-if="tipo == 3" class="p-4">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">Tipo</label>
                    <select v-model="tipoPersona" class="form-select form-select-sm">
                        <option selected disabled value="0">--Selecciona</option>
                        <option value="1">Fisica</option>
                        <option value="2">Moral</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label class="form-label">RFC</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="rfc" @input="validateRFC">
                        <span class="invalidEmail" v-if="!valiRFC">Por favor, introduce un RFC válido.</span>
                    </div>
                </div>
            </div>
            <div class="row" v-if="tipoPersona == 1">
                <div class="col-md-4">
                    <label class="form-label">Nombres(s)</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="nombres">
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Apellido Paterno</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="paterno">
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Apellido Materno</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="materno">
                    </div>
                </div>
            </div>
            <div class="row " v-if="tipoPersona == 2">
                <div class="col-md-6">
                    <label class="form-label">Razon Social</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="razon">
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Nombre Comercial</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="nombreComercial">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <label class="form-label">Email</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="email" class="form-control" v-model="email">
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Teléfono de Contacto</label>
                    <div class="input-group input-group-sm mb-3">
                        <input type="text" class="form-control" v-model="telefono">
                    </div>
                </div>
            </div>
        </div>
        <div v-if="tipo != 0" class="">
            <div class="row pl-4">
                <div class="col-md-4">
                    <label class="form-label">¿Usted pertenece a la red?</label>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-check ml-4">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="Si" v-model="red">
                                <label class="form-check-label" for="flexRadioDefault1">
                                    Si
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="No" v-model="red">
                                <label class="form-check-label" for="flexRadioDefault1">
                                    No
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-md-7" v-if="red == 'No'">
                    <label class="form-label">¿Desea pertenecer a nuestra red de Proveedores?</label>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-check ml-4">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="Si" v-model="checkProveedores">
                                <label class="form-check-label" for="flexRadioDefault1">
                                    Si
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="No" v-model="checkProveedores">
                                <label class="form-check-label" for="flexRadioDefault1">
                                    No
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <!-- <div class="col-md-8">
                    <vue-recaptcha
                        sitekey="6Le6KAwcAAAAAHxMleQ5SVIUZ0jLIU2yzhahk8zM"
                    ></vue-recaptcha>
                </div> -->
            </div>
            <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4 float-right mb-4">
                    <button class="btn btn-danger float-right" style="border-radius: 15px;" @click="closeModal" ><i class="fas fa-times-circle mr-2"></i>Cerrar</button>
                </div>
                <div class="col-md-4 float-right mb-4">
                    <button class="btn btn-primary" :disabled="!valiRFC || !validEmailHonorarios || !validEmailHospitales"  @click="enviarFormulario"> <i class="fas fa-check-circle mr-2"></i>Validar datos</button>
                </div>

            </div>
        </div>

    </div>
    </modal>
</template>

<script>
import VueRecaptcha from "../../../../node_modules/vue-recaptcha";

export default {
    components: {
        VueRecaptcha,
    },
    props: {
        onChangeFile: Function,
        getCP: Function,
        file: Array,
        validCP: Boolean,
        colonias: Array,
        estado_s: String,
        municipio_s: String,
        cleanModal: Boolean
    },
    data() {
        return { 
            //hospitales
            rfc: '',
            razon: '',
            nombreComercial: '',
            emailHospitales: '',
            //honorarios
            emailHonorarios: '',
            paterno: '',
            materno: '',
            nombres: '',
            rfcHonorarios: '',
            telefono: '',
            //Proveedor
            rfcProvee: '',
            nombreComerProvee: '',
            nombresProvee: '',
            paternoProvee: '',
            maternoProvee: '',
            emailProvee: '',
            telefonoProvee: '',
            razonProvee: '',
            tipoPersona: 0,
            
            red: '',
            checkProveedores: '',
            tipo: 0,
            validEmailHospitales: true,
            validEmailHonorarios: true,
            valiRFC: true
          
      }
    },
    watch: {
    cleanModal(value) {
        if (value) {
            this.limpiarControles();
        }
    },
  },
    methods:{
        enviarFormulario(){
            let datosFormularios = {
                'RFC': this.rfc,
                'Razon_Social': this.razon,
                'Nombre_Comercial': this.nombreComercial,
                'Email': this.email,
                // 'Email_Hospitales': this.email,
                'Apellido_Paterno': this.paterno,
                'Apellido_Materno': this.materno,
                'Nombre_s': this.nombres,
                // 'Email_Honorarios': this.email,
                'Telefono': this.telefono,
                'Tipo_Persona': this.tipoPersona,
                // 'Telefono_Provee': this.telefonoProvee,
                'Proveedores': this.checkProveedores,
                'Tipo': this.tipo
                
            }

            this.$emit('formularioCompletado', datosFormularios);
        },
        validateRFC(){
            const emailRegex = /^[a-zA-Z0-9]+$/;

            this.valiRFC = emailRegex.test(this.rfc);
        },
        validateEmail() {
            const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;

            if (this.tipo == 1) { this.validEmailHospitales = emailRegex.test(this.email); } 
            else if (this.tipo == 2) { this.validEmailHonorarios = emailRegex.test(this.email); } 
        }, 
        changeTipo(){
            this.rfc = ''
            this.razon = ''
            this.nombreComercial = ''
            this.email = ''
            // this.emailHospitales = ''
            this.paterno = ''
            this.materno = ''
            this.nombres = ''
            // this.emailHonorarios = ''
            this.telefono = ''
            this.tipoPersona = ''
            // this.emailProvee = ''
            // this.telefonoProvee = ''
            this.red = ''
        },
        closeModal(){
            this.$modal.hide('registro')
            this.tipo = 0
            this.rfc = ''
            this.razon = ''
            this.nombreComercial = ''
            this.email = ''
            this.paterno = ''
            this.materno = ''
            this.nombres = ''
            this.telefono = ''
            this.tipoPersona = ''
            this.red = ''
        },
        limpiarControles() {
            this.tipo = 0;
            this.rfc = '';
            this.razon = '';
            this.nombreComercial = '';
            this.email = '';
            this.paterno = '';
            this.materno = '';
            this.nombres = '';
            this.telefono = '';
            this.tipoPersona = '';
            this.red = '';
        },
    },
    mounted() {
    },
}
</script>
<style scoped>
.invalidEmail{
    font-size: small;
    color: red;
}
.file-select {
    position: relative;
    display: inline-block;
    width: 330px;
    height: 30px;
    margin-right: 20px;
    cursor: pointer;
    /* Añade un borde alrededor del elemento */
    border: 1px solid #cccccca6;
    border-radius: 5px;

}

.file-select::before {
    background-color: #ffffff;
    color: rgba(153, 152, 152, 0.548);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: small;
    content: "Seleccionar archivo";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.col-md-6, .col-md-5, .col-md-3, .col-md-4 {
    padding-right: 7px !important;
    padding-left: 7px !important;
}
.btn-primary{
    background-color: #1e536b !important;
    border-color: #1e536b !important;
}
.btn-secondary{
    background-color: #276E90 !important;
    border-color: #276E90 !important;
    color: white;
}
.vm--modal {
  border-radius: 90px !important;
  }
</style>